import set from 'lodash/set';
import messages from './messages';

export default function setStudyOptionsLabels(studyOptions) {
  const options = { ...studyOptions };
  set(options, 'studyAbroadCredit.label', messages.optionAbroadCredit);
  set(options, 'studyAbroadNonCredit.label', messages.optionAbroadNonCredit);
  set(options, 'graduateStudyAbroadCredit.label', messages.optionGraduateAbroadCredit);
  set(
    options,
    'graduateStudyAbroadNonCredit.label',
    messages.optionGraduateAbroadNonCredit,
  );
  set(options, 'studyAbroad.label', messages.optionAbroad);
  set(options, 'graduateStudyAbroad.label', messages.optionGraduateAbroad);
  set(options, 'teacherCertificationPrograms.label', messages.optionTeacher);
  set(options, 'combinedDegreePrograms.label', messages.optionCombined);
  set(options, 'domesticStudyAwayPrograms.label', messages.optionDomestic);
  set(options, 'weekendEveningPrograms.label', messages.optionWeekendEvening);
  set(options, 'acceleratedProgram.label', messages.optionAccelerated);
  set(options, 'doubleMajor.label', messages.optionDouble);
  set(options, 'externalDegreeProgram.label', messages.optionExternal);
  set(options, 'honorsProgram.label', messages.optionHonors);
  set(options, 'independentStudy.label', messages.optionIndependent);
  set(options, 'internships.label', messages.optionInternship);
  set(options, 'weekendCollege.label', messages.optionWeekend);
  set(options, 'cooperativeEducationPrograms.label', messages.optionCooperative);
  return options;
}
